<template>
  <div>
    <v-text-field
      ref="refinput"
      v-model="cmpValue"
      v-disabled-icon-focus
      :label="label"
      :flat="flat"
      :solo="solo"
      type="tel"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
      :error="error"
      :error-messages="errorMessages"
      :rules="rules"
      :height="height"
      :clearable="clearable"
      :background-color="($vuetify.theme.isDark ? '#272727' : 'white')"
      :prefix="options.prefix"
      :suffix="options.suffix"
      v-bind="properties"
      :autofocus="autofocus"
      @keypress="keyPress"
      @blur="onBlur"
      @focus="(!autofocus ? focusEvent : false)"
    >
      <template v-slot:append>
        <!--        <v-icon-->
        <!--          v-if="percent"-->
        <!--          color="primary"-->
        <!--          style="font-size: 18px"-->
        <!--          @click="percentStatus = !percentStatus"-->
        <!--        >-->
        <!--          {{ (percentStatus ? 'mdi-percent-outline' : 'mdi-currency-usd') }}-->
        <!--        </v-icon>-->
        <v-icon
          color="primary"
          style="font-size: 18px;margin-top: 2px;"
          @click="$emit('append')"
        >
          {{ appendIcon }}
        </v-icon>
        <v-btn
          v-show="cmpValue && mClearable"
          color="primary"
          icon
          small
          style="margin-top: 9px"
          tabindex="-1"
          @click.stop.prevent="cmpValue = null"
        >
          <v-icon
            style="font-size: 26px"
          >
            mdi-close
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:prepend-inner>
        <v-btn
          v-if="numpad"
          color="primary"
          icon
          x-small
          tabindex="-1"
          @click="openNumpad"
        >
          <v-icon style="font-size: 26px;margin-top: 2px">
            mdi-calculator
          </v-icon>
        </v-btn>
      </template>
    </v-text-field>
    <v-dialog
      v-model="numpadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="325"
    >
      <v-card style="background-color: #e3e3e3">
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="numpadDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
          <h3 class="mx-auto font-weight-medium mt-2">
            {{ $t(numpadLable) }}
          </h3>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-1 mx-0 mt-0"
          >
            <numpad
              :input="numpadValue"
              :label="numpadLable"
              @save="setNumpad"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    directives: {
      disabledIconFocus: {
        bind (el) {
          el.querySelectorAll('.v-input__icon button').forEach(x => x.setAttribute('tabindex', -1))
        },
      },
    },
    components: {
      numpad: () => import('./../numpad/index.vue'),
    },
    model: { prop: 'value', event: 'input' },
    props: {
      autofocus: {
        type: Boolean,
        default: false,
      },
      numpad: {
        type: Boolean,
        default: false,
      },
      value: {
        // type: String,
        type: [String, Number],
        default: '0',
      },
      label: {
        type: String,
        default: '',
      },
      height: {
        type: String,
        default: '',
      },
      mClearable: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: undefined,
      },
      appendIcon: {
        type: String,
        default: undefined,
      },
      flat: {
        type: Boolean,
        default: true,
      },
      percent: {
        type: Boolean,
        default: false,
      },
      solo: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      dense: {
        type: Boolean,
        default: false,
      },
      error: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: [Boolean, String],
        default: false,
      },
      errorMessages: {
        type: [Array, String],
        default: () => [],
      },
      rules: {
        type: [Array, String],
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      backgroundColor: {
        type: String,
        default: 'white',
      },
      valueWhenIsEmpty: {
        type: String,
        default: '', // "0" or "" or null
      },
      valueOptions: {
        type: Object,
        default: function () {
          return {
            min: 0,
            minEvent: 'SetValueMin',
            max: 99999999999999999999999,
            maxEvent: 'SetValueMax',
          }
        },
      },
      options: {
        type: Object,
        default: function () {
          return {
            locale: 'pt-BR',
            prefix: '',
            suffix: '',
            length: 11,
            precision: 2,
          }
        },
      },
      // Other v-text-field properties
      properties: {
        type: Object,
        default: function () {
          return {}
        },
      },
    },
    data: () => ({
      numpadDialog: false,
      setDecimal: false,
      numpadValue: 0,
      numpadLable: null,
      decimalNumber: 0,
      percentStatus: false,
    }),
    /*
     v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
     O valor digitado entra pelo newValue do Set e é emitido para o componente pai.
     the-vue-mask nao funciona corretamente ao incluir valores existentes no componente pai.
    */
    computed: {
      cmpValue: {
        get: function () {
          if (this.value !== null && this.value !== '' && this.value > 0) {
            var num = this.value.toString().replace(/,/g, '')
            if (this.options.precision !== undefined && this.options.precision > 0) {
              num = parseFloat(num).toFixed(4)
            } else {
              num = parseFloat(num).toFixed(0)
            }
            var ex = parseFloat(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            return ex
          } else {
            return 0
          }
          // return this.value !== null && this.value !== ''
          //   ? this.humanFormat(this.value.toString())
          //   : this.valueWhenIsEmpty
        },
        set: function (newValue) {
          var clearNumber
          if (newValue) {
            clearNumber = newValue.replace(/,/g, '')
            if (this.options.precision !== undefined && this.options.precision > 0) {
              clearNumber = parseFloat(clearNumber).toFixed(4)
            } else {
              clearNumber = parseFloat(clearNumber).toFixed(0)
            }
          } else {
            clearNumber = newValue
          }
          // newValue = clearNumber
          this.$emit('input', clearNumber)
          return clearNumber
          // this.$emit('input', this.machineFormat(newValue))
        },
      },
    },
    watch: {
      percentStatus (val, old) {
        this.cmpValue = 0
        this.$emit('input', 0)
        this.$emit('changePercent', this.percentStatus)
      },
    },
    methods: {
      setFocus () {
        this.$refs.refinput.focus()
      },
      openNumpad () {
        if (this.value === '0.00') {
          this.numpadValue = '0'
        } else {
          this.numpadValue = this.value
        }
        this.numpadLable = this.$t(this.label)
        this.numpadDialog = true
      },
      setNumpad (data) {
        this.cmpValue = data
        this.numpadDialog = false
      },
      precision (a) {
        if (!isFinite(a)) return 0
        var e = 1; var p = 0
        while (Math.round(a * e) / e !== a) { e *= 10; p++ }
        return p
      },
      ParseFloat (str, val) {
        str = str.toString()
        str = str.slice(0, (str.indexOf('.')) + val + 1)
        return Number(str)
      },
      humanFormat: function (number) {
        if (isNaN(number)) {
          number = ''
        } else {
          // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
          number = Number(number).toLocaleString(this.options.locale, {
            maximumFractionDigits: this.options.precision,
            minimumFractionDigits: this.options.precision,
          })
        }
        return number
      },
      machineFormat (number) {
        if (number) {
          if (this.options.precision === undefined) {
            this.options.precision = 0
          }
          number = this.cleanNumber(number)
          // Ajustar quantidade de zeros à esquerda
          number = number.padStart(parseInt(this.options.precision) + 1, '0')
          // Incluir ponto na casa correta, conforme a precisão configurada
          number =
            number.substring(
              0,
              number.length - parseInt(this.options.precision),
            ) +
            '.' +
            number.substring(
              number.length - parseInt(this.options.precision),
              number.length,
            )
          if (isNaN(number)) {
            number = this.valueWhenIsEmpty
          }
        } else {
          number = this.valueWhenIsEmpty
        }
        if (this.options.precision === 0) {
          number = this.cleanNumber(number)
        }
        return number
      },
      isFloat (n) {
        return Number(n) === n && n % 1 !== 0
      },
      keyPress ($event) {
        const keyCode = $event.keyCode ? $event.keyCode : $event.which
        if (keyCode === 46 && this.options.precision === 0) {
          $event.preventDefault()
        }
        if (keyCode === 46 && this.options.precision > 0 && this.isFloat(parseFloat(this.value))) {
          $event.preventDefault()
        }
        if (keyCode < 1000 && (keyCode < 48 || keyCode > 57) && keyCode !== 46) {
          // if (keyCode < 48 || keyCode > 57) {1776 --1785
          // 46 is dot
          $event.preventDefault()
        }
        if (keyCode > 1000 && (keyCode < 1776 || keyCode > 1785) && keyCode !== 46) {
          // if (keyCode < 48 || keyCode > 57) {1776 --1785
          // 46 is dot
          $event.preventDefault()
        }
        // if (this.targetLength()) {
        //   $event.preventDefault()
        // }
      },
      // Retira todos os caracteres não numéricos e zeros à esquerda
      cleanNumber: function (value) {
        let result = ''
        if (value) {
          let flag = false
          const arrayValue = value.toString().split('')
          for (var i = 0; i < arrayValue.length; i++) {
            if (this.isInteger(arrayValue[i])) {
              if (!flag) {
                // Retirar zeros à esquerda
                if (arrayValue[i] !== '0') {
                  result = result + arrayValue[i]
                  flag = true
                }
              } else {
                result = result + arrayValue[i]
              }
            }
          }
        }
        return result
      },
      isInteger (value) {
        let result = false
        if (Number.isInteger(parseInt(value))) {
          result = true
        }
        return result
      },
      targetLength () {
        if (
          Number(this.cleanNumber(this.value).length) >=
          Number(this.options.length)
        ) {
          return true
        } else {
          return false
        }
      },
      onBlur () {
        if (this.value) {
          var str = this.value.toString().split('.')
          if (str[1] > 0) {
            var app = this
            setTimeout(function () {
              // app.cmpValue = app.cmpValue.toFixed((app.options.precision < 4 ? app.options.precision : 4)).replace(/\.0+$/, '')
              app.cmpValue = str[0].toString() + '.' + str[1].substr(0, app.options.precision).toString()
            }, 2)
            // this.cmpValue = str[0].toString()
          }
          if (
            this.value.length === 0 ||
            parseFloat(this.value) <= this.valueOptions.min
          ) {
            this.$emit(
              this.valueOptions.minEvent || 'SetValueMin',
              this.valueOptions.min,
            )
          }
          if (
            typeof this.valueOptions.max !== 'undefined' &&
            parseFloat(this.value) > parseFloat(this.valueOptions.max)
          ) {
            this.$emit(
              this.valueOptions.maxEvent || 'SetValueMax',
              this.valueOptions.max,
            )
          }
        }
      },
    },
  }
</script>
